import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getTestimonial } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
function Alumni() { 
  useEffect(() => {
    document.title = 'Alumni -  Mercy Memorial School, Kanpur';  
}, []); 
const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const data = await getTestimonial();  
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Alumni</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Alumni</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                 {data.length > 0 ? data.map((item,index) => (
                  <div className="blogbox" key={index}>
                  <div className="blogboximg">
                      <LazyLoad><img src={`https://webapi.entab.info/api/image/${item.attachments}`}  className="img-fluid" alt="" /></LazyLoad>
                   </div>
                  <div className="blogboxdesc">
                       <h6>{item.title}</h6>
                       <div className="blogboxmsg"> <p> </p>
                       </div>
                       <div className="blogboxinfo">
                          <p className="blogname">{item.name}<span> {item.designation}</span></p>
                          <p className="blogdate">{item.batch}</p>
                       </div>
                  </div>
                  </div>
                 )):( <>
                  <div className="blogbox">
                  <div className="blogboximg">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Noopur.jpg" className="img-fluid" alt="" /></LazyLoad>
                  </div>
                  <div className="blogboxdesc">  
                        <p>1. Won NUJS Tax BP Saraf Moot Court Competition, 20214 Organised by NUJS Law University.</p>
                        <p>2. Won Best Memorial at 3rd IP National Moot Court Competition, IIT Kharagpur in 2014.</p>
                        <p>3. Published Researc Paper titles "Disability Bill 2014: Power or Disability" Issue 1 Vol 1 of the Centre for disability Law & Avocacy Newsletter, NLUO (April, 2015)</p>
                        <p>4. Published paper titled 'Trends of Indian Chauvinism:High Time to Sign the Tome Statute' in Issue III Vol 2 of ILNUE-Journal, Student Law Review, Nirma Law University.(2014)</p>
                        <p>5. Awarded a Certificate of Participation with a Distinction for submitting an essay titled 'The Indian compliance with the biodiversity standards; with specific reference to the Bt-Brinjal debate' in Rostrum's National Essay Competition 2013-14</p> 
                    
                     <div className="blogboxinfo">
                        <p className="blogname"> Noopur Srivastava<span> Civil Judge (Sr. Div) . Additional Chief Judicial Magistrate, Gautambudh Nagar (Noida) </span></p>
                        <p className="blogdate"> ISC, 2010</p>
                     </div>
                  </div>
              </div>
              <div className="blogbox">
              <div className="blogboximg">
                <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Yashveer.jpg" className="img-fluid" alt="" /></LazyLoad>
              </div>
              <div className="blogboxdesc">  
                    
                 <div className="blogboxinfo">
                    <p className="blogname"> Yashveer Singh <span> Assistant Commandant (CRPF) Allahabad High Court Security) </span></p>
                    <p className="blogdate"> ISC, 2010</p>
                 </div>
              </div>
          </div>
          <div className="blogbox">
                  <div className="blogboximg">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/Shubham.jpg" className="img-fluid" alt="" /></LazyLoad>
                  </div>
                  <div className="blogboxdesc">  
                        <p> As Suprintendent of Police, major responsibility lies in maintenance of Law and Order in the district and prevention and investigation of major crimes including arrest of the accused, preparation of Charge Sheet after thorough investigation and also ensuring effective prosecution and conviction of accused.</p> 
                    
                     <div className="blogboxinfo">
                        <p className="blogname"> Shubham  Patel<span> INDIAN POLICE SERVICE (IPS) Officer of 2016 Batch of UP Cadre. SP Hamirpur District, DCP Ghaziabad, SP Intelligence Lucknow. </span></p>
                        <p className="blogdate"> ISC, 2009</p>
                     </div>
                  </div>
              </div>
                  </>
             ) 
                 }
           </div>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
}

export default Alumni;
